import * as React from 'react';
import { SpecialistTypeContainer } from './containers/SpecialistTypeContainer';
import { DealTypeContainer } from './containers/DealTypeContainer';
import { OfferTypeContainer } from './containers/OfferTypeContainer';
import { SearchTextContainer } from './containers/SearchTextContainer';

export const SearchRealtorsFiltersContainer: React.FC = () => {
  return (
    <React.Fragment>
      <SpecialistTypeContainer />
      <DealTypeContainer />
      <OfferTypeContainer />
      <SearchTextContainer />
    </React.Fragment>
  );
};

SearchRealtorsFiltersContainer.displayName = 'SearchRealtorsFiltersContainer';
